import { render, staticRenderFns } from "./ecrlist.vue?vue&type=template&id=a6201e08&scoped=true&"
import script from "./ecrlist.vue?vue&type=script&lang=js&"
export * from "./ecrlist.vue?vue&type=script&lang=js&"
import style0 from "./ecrlist.vue?vue&type=style&index=0&id=a6201e08&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6201e08",
  null
  
)

export default component.exports